import React from 'react';
export function Guarantee() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(240,253,244) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-186">
      <div className="mx-auto max-w-2xl" data-id="element-187">
        <div className="rounded-2xl overflow-hidden shadow-md" style={{
        border: '1px solid rgba(34,197,94,0.35)'
      }} data-id="element-188">

          {/* Header */}
          <div className="px-6 py-5 text-center" style={{
          background: 'linear-gradient(135deg, rgb(21,128,61), rgb(22,163,74))'
        }} data-id="element-189">
            <div className="text-4xl mb-2" data-id="element-190">🛡️</div>
            <h2 className="text-lg sm:text-xl font-black text-white m-0" data-id="element-191">
              GARANTÍA MEGAPACK™ — 7 DÍAS
            </h2>
            <p className="text-xs text-white/70 m-0 mt-1" data-id="element-192">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
          </div>

          {/* Body */}
          <div className="px-6 py-6" style={{
          backgroundColor: 'rgb(240,253,244)'
        }} data-id="element-193">
            <p className="text-sm text-gray-600 text-center m-0 mb-5" data-id="element-194">
              Abrís los tomos, revisás los bonos y los usás en consulta.
              Si en 7 días no es lo que esperabas, te devolvemos el dinero.
            </p>

            {/* 3 puntos clave */}
            <div className="grid grid-cols-3 gap-3 mb-5" data-id="element-195">
              {[{
              icon: '✅',
              text: 'Devolución inmediata'
            }, {
              icon: '🔒',
              text: 'Sin burocracia'
            }, {
              icon: '💬',
              text: 'Un solo mensaje'
            }].map(item => <div key={item.text} className="flex flex-col items-center gap-1.5 rounded-xl px-3 py-3 text-center" style={{
              backgroundColor: 'rgb(255,255,255)',
              border: '1px solid rgba(34,197,94,0.2)'
            }} data-id="element-196">
                  <span className="text-xl" data-id="element-197">{item.icon}</span>
                  <span className="text-[11px] font-bold text-gray-700 leading-tight" data-id="element-198">
                    {item.text}
                  </span>
                </div>)}
            </div>

            <p className="text-2xl font-black text-green-700 text-center m-0" data-id="element-199">
              Te devolvemos el 100%.
            </p>
          </div>

          {/* Footer */}
          <div className="px-6 py-3 text-center border-t" style={{
          backgroundColor: 'rgb(255,255,255)',
          borderColor: 'rgba(34,197,94,0.15)'
        }} data-id="element-200">
            <p className="text-xs text-gray-400 m-0" data-id="element-201">
              +400 nutricionistas ya lo usan · Tasa de devolución menor al 1%
            </p>
          </div>

        </div>
      </div>
    </section>;
}